import { ThemedText } from '@/components/themed-text';
import React from 'react';
import { Pressable, View } from 'react-native';

export type TabKey = 'details' | 'enrollments' | 'schedules' | 'charge' | 'service';

export type TabConfig = {
  key: TabKey;
  title: string;
};

type ServiceTabHeaderProps = {
  tabs: TabConfig[];
  activeTab: TabKey;
  onTabChange: (tabKey: TabKey) => void;
  isEditing: boolean;
  /**
   * Quando `false`, as abas permanecem clicáveis mesmo com `isEditing` (ex.: formulário multi-aba de contrato).
   * Quando omitido, usa `isEditing` para desabilitar navegação (ex.: edição de serviço).
   */
  disableTabNavigation?: boolean;
  /** Quando definido, o tab com a chave recebe testID (ex: charge → enrollment-detail-tab-charge) */
  tabTestIDs?: Partial<Record<TabKey, string>>;
};

export function ServiceTabHeader({
  tabs,
  activeTab,
  onTabChange,
  isEditing,
  disableTabNavigation,
  tabTestIDs,
}: ServiceTabHeaderProps) {
  const navigationDisabled = disableTabNavigation ?? isEditing;
  return (
    <View className={`w-full px-5 ${navigationDisabled ? 'opacity-60' : ''}`}>
      <View className="flex-row items-end gap-6 pb-1">
        {tabs.map(({ key, title }) => {
          const isActive = activeTab === key;
          const testID = tabTestIDs?.[key];
          return (
            <Pressable
              key={key}
              onPress={() => onTabChange(key)}
              className="flex-shrink-0 py-2"
              disabled={navigationDisabled}
              testID={testID}
            >
              <ThemedText
                className={`font-medium text-sm ${
                  isActive ? 'text-primary' : 'text-muted-foreground'
                }`}
                numberOfLines={1}
              >
                {title}
              </ThemedText>
              {isActive && <View className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />}
            </Pressable>
          );
        })}
      </View>
    </View>
  );
}
